import * as Q from "q";
import * as globalConfig from "globalConfig";

// Models
import { PhoneConfigurationResponse, DropdownOptionsResponse } from "Content/ts/Models/Account/Profile/profileConfiguration";
import { ContactVicinityResponse } from "Content/ts/Models/Contact/Details/contactDetailsSummary";

export module SharedAccountDetailsService {
    export function RetrievePhoneNumberConfiguration(): Q.Promise<PhoneConfigurationResponse> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Profile.PhoneConfiguration,
            type: "GET",
            cache: false
        }));
    }

    export function RetrieveDropdownOptions(): Q.Promise<DropdownOptionsResponse> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.Profile.ProfileDropdowns,
            type: "GET",
            cache: false
        }));
    }


    export function Vicinities(contactId: number): Q.Promise<Array<ContactVicinityResponse>> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.PersonalProfile.Vicinities,
            data: {
                ContactId: contactId
            },
            type: "GET",
            cache: false
        }));
    }
}